import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { getContracts, getClients, getPlans, setClientPlan } from '../../services/api';

const ContractsAdminPage = ({ token }) => {
  const [contracts, setContracts] = useState([]);
  const [clients, setClients] = useState([]);
  const [plans, setPlans] = useState([]);
  const [clientId, setClientId] = useState('');
  const [planId, setPlanId] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    const [contractsRes, clientsRes, plansRes] = await Promise.all([
      getContracts(token),
      getClients(token),
      getPlans(token),
    ]);
    if (contractsRes.cod === 200) setContracts(contractsRes.data || []);
    if (clientsRes.cod === 200) setClients(clientsRes.data || []);
    if (plansRes.cod === 200) setPlans(plansRes.data || []);
  };

  useEffect(() => { load(); }, [token]);

  const handleSave = async () => {
    if (!clientId || !planId) return;
    const res = await setClientPlan(token, Number(clientId), Number(planId));
    if (res.cod !== 200) {
      setError(res.message || 'No se pudo actualizar el contrato');
      return;
    }
    setError('');
    setClientId('');
    setPlanId('');
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Contratos</h1>
        <p className="text-sm text-gray-500 mt-1">Asigna o cambia plan por cliente</p>
      </div>

      {error && (
        <div className="mb-4 px-4 py-3 rounded-lg border border-red-200 bg-red-50 text-red-700 text-sm">
          {error}
        </div>
      )}

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 mb-6 grid grid-cols-1 md:grid-cols-3 gap-3">
        <select value={clientId} onChange={(e) => setClientId(e.target.value)} className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option value="">Selecciona cliente</option>
          {clients.map((c) => <option key={c.id} value={c.id}>{c.razon_social || c.nombre}</option>)}
        </select>
        <select value={planId} onChange={(e) => setPlanId(e.target.value)} className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
          <option value="">Selecciona plan</option>
          {plans.map((p) => <option key={p.id} value={p.id}>{p.nombre} ({p.max_terminales})</option>)}
        </select>
        <button onClick={handleSave} className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-medium">
          <FaSave className="w-3.5 h-3.5" /> Guardar contrato
        </button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              <th className="text-left px-4 py-3 text-xs uppercase text-gray-600">Cliente</th>
              <th className="text-left px-4 py-3 text-xs uppercase text-gray-600">Plan</th>
              <th className="text-left px-4 py-3 text-xs uppercase text-gray-600">Límite</th>
              <th className="text-left px-4 py-3 text-xs uppercase text-gray-600">Estado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {contracts.map((c) => (
              <tr key={c.id}>
                <td className="px-4 py-3">{c.razon_social || c.cliente_nombre}</td>
                <td className="px-4 py-3">{c.plan_nombre}</td>
                <td className="px-4 py-3">{c.max_terminales}</td>
                <td className="px-4 py-3"><span className="inline-flex px-2 py-0.5 rounded-full bg-green-50 text-green-700 text-xs">{c.estado}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractsAdminPage;
